<template>
  <div class="section-content" >
      <div class="sticker">
        <div
          v-show="componentListWithBg.length === 9"
          class="sticker-content sticker-modules-container"
          :style="{ background: `url(${backgroundImg}) 0% 0% / 100% no-repeat`}"
        >
          <div v-for="lineItem in lineArr" :key="lineItem.id" :style="lineItem.style2"></div>
          <div class="sticker-content-left">
            <component
              v-ratio="{ ratio: 1 / 0.618, fixed: 'width',  debounce: 100 }"
              v-for="item in componentListWithBg.slice(0, 3)"
              :style="{ width: item.cellWidth }"
              :key="item.CARDCODE"
              :is="item.CARDCODE"
              :min-width="1"
              :min-height="1"
              :max-width="item.MAXWIDTH"
              :max-height="item.MAXHEIGHT"
              :bg-color="item.bgColor"
              :blur-background-img="item.blurBackgroundImg"
              :content-visible-stu="item.contentVisibleStu"
              @updateContentVisible="updateContentVisible"
              :sequence="item.SEQUENCE"
            />
          </div>
          <div class="sticker-content-right">
            <component
              v-ratio="{ ratio: 1 / 0.618, fixed: 'width',  debounce: 100 }"
              v-for="item in componentListWithBg.slice(3, componentListWithBg.length)"
              :style="{ width: item.cellWidth }"
              :key="item.CARDCODE"
              :is="item.CARDCODE"
              :min-width="1"
              :min-height="1"
              :max-width="item.MAXWIDTH"
              :max-height="item.MAXHEIGHT"
              :bg-color="item.bgColor"
              :blur-background-img="item.blurBackgroundImg"
              :content-visible-stu="item.contentVisibleStu"
              :sequence="item.SEQUENCE"
              @updateContentVisible="updateContentVisible"
            />
          </div>
        </div>
        <div class="sticker-content" >
          <Title :title="serveTitle" :english-title="serveEnglishTitle"></Title>
          <SortServe :serve-url="serveUrl" :request="request" code="student"></SortServe>
        </div>

      </div>

  </div>
</template>
<script>
  import { getUserComponents } from '@/api/user';
  import { mapGetters } from 'vuex';
  import ColorThief from 'colorthief';
  import config from '@/configs';
  import { rgbToHsl } from '../../utils/getColorsViaPic.js';

  export default {
    name: 'Student',
    computed: {
      ...mapGetters(['serveUrl', 'request', 'flowServeUrl', 'themeConfig',  "token"]),
      backgroundImg() {
        if (this.themeConfig.currentSkinItem) {
          let skinBgImg = this.themeConfig.currentSkinItem.preview;
          if (skinBgImg) {
            return skinBgImg;
          }
        } else if (this.config && this.config.VUE_APP_SKIN_IMG_URL) {
          return this.config.VUE_APP_SKIN_IMG_URL;
        }
        return require('@/assets/Background/home.jpg');
      },
      config() {
        return config;
      },
    },
    watch: {
      backgroundImg(newVal, oldVal) {
        this.getColors();
      }
    },
    components: {

      MiniApp: () => import('@/components/MiniApp'),
      News: () => import('./Sticker/News'),
      Message: () => import('./Sticker/Message'),
      Service: () => import('./Sticker/Service'),
      Mail: () => import('./Sticker/Mail'),
      Book: () => import('./Sticker/Book'),
      OCP: () => import('./Sticker/OCP'),
      Grade: () => import('./Sticker/Grade'),
      Schedule: () => import('./Sticker/Schedule'),
      Research: () => import('./Sticker/Research'),
      Paper: () => import('./Sticker/Paper'),
      Collection: () => import('./Sticker/Collection'),
      Title: () => import('./components/Title'),
      Events: () => import('./Sticker/Events')
    },
    data() {
      return {
        serveTitle: '校园旅程',
        serveEnglishTitle: 'campus journey',
        lineArr: [
          { id: 1, style2: { width: '100%', height: '4px', backgroundColor: 'rgba(255,255,255,0.8)', position: 'absolute', left: 0, top: '66.6%' } },
          {
            id: 2,
            style2: { width: '4px', height: '100%', backgroundColor: 'rgba(255,255,255,0.8)', position: 'absolute', left: '50%', top: '0' }
          },
          {
            id: 3,
            style2: { width: '4px', height: '100%', backgroundColor: 'rgba(255,255,255,0.8)', position: 'absolute', left: '75%', top: '0' }
          },
          {
            id: 4,
            style2: { width: '4px', height: '33.4%', backgroundColor: 'rgba(255,255,255,0.8)', position: 'absolute', left: '25%', top: '66.6%' }
          },
          {
            id: 5,
            style2: { width: '50%', height: '4px', backgroundColor: 'rgba(255,255,255,0.8)', position: 'absolute', left: '50%', top: '33.4%' }
          }
        ],
        // 组件列表
        componentList: [
          {
            CARDCODE: 'News',
            PARENTID: '2',
            MAXWIDTH: 2,
            SEQUENCE: 0,
            CARDNAME: '资讯中心',
            ISCOLLECT: 1,
            CARDPICTUREURL: 'service/servicePic/1585408871091_45d1a0ae-b227-4c0b-8134-3469e3c2823c.png',
            MAXHEIGHT: 2,
            ID: '2001',
            DRAGGABLE: 0,
            CONFIGURABLE: 1,
            TABTYPE: null,
            cellWidth: '100%',
            bgColor: 'hsla(168, 48%, 54%, 0.86)',
            blurBackgroundImg: require('@/assets/Home/Sticker/news.jpg'),
            contentVisibleStu: false
          },
          {
            CARDCODE: 'Collection',
            PARENTID: '2',
            MAXWIDTH: 200,
            SEQUENCE: 1,
            CARDNAME: '收藏中心',
            ISCOLLECT: 1,
            CARDPICTUREURL: 'service/servicePic/1585408799297_2964ce52-119b-402a-8ff7-c09c4ae95f2d.png',
            MAXHEIGHT: 2,
            ID: '2010',
            DRAGGABLE: 1,
            CONFIGURABLE: 1,
            TABTYPE: null,
            cellWidth: '50%',
            bgColor: 'hsla(173, 14%, 52%, 0.86)',
            blurBackgroundImg: require('@/assets/Home/Sticker/news.jpg'),
            contentVisibleStu: false
          },
          {
            CARDCODE: 'Message',
            PARENTID: '2',
            MAXWIDTH: 200,
            SEQUENCE: 2,
            CARDNAME: '消息中心',
            ISCOLLECT: 1,
            CARDPICTUREURL: 'service/servicePic/1585408852416_1a5685f7-6877-4648-af91-8fbc97112167.png',
            MAXHEIGHT: 2,
            ID: '2003',
            DRAGGABLE: 1,
            CONFIGURABLE: 1,
            TABTYPE: null,
            cellWidth: '50%',
            bgColor: 'hsla(115, 27%, 63%, 0.86)',
            blurBackgroundImg: require('@/assets/Home/Sticker/news.jpg'),
            contentVisibleStu: false
          },
          {
            CARDCODE: 'Service',
            PARENTID: '2',
            MAXWIDTH: '199%',
            SEQUENCE: 3,
            CARDNAME: '热门服务',
            ISCOLLECT: 1,
            CARDPICTUREURL: 'service/servicePic/1585408944707_ccf1ef77-f5fd-4a9c-8a31-10d925eb203b.png',
            MAXHEIGHT: 2,
            ID: '2005',
            DRAGGABLE: 1,
            CONFIGURABLE: 0,
            TABTYPE: null,
            cellWidth: '50%',
            bgColor: 'hsla(215, 29%, 56%, 0.86)',
            blurBackgroundImg: require('@/assets/Home/Sticker/news.jpg'),
            contentVisibleStu: false
          },
          {
            CARDCODE: 'OCP',
            PARENTID: '2',
            MAXWIDTH: '99%',
            SEQUENCE: 4,
            CARDNAME: '一卡通',
            ISCOLLECT: 1,
            CARDPICTUREURL: 'service/servicePic/1585408893368_9e6ca050-2d16-4974-b2e0-d1462d0ea655.png',
            MAXHEIGHT: 1,
            ID: '2008',
            DRAGGABLE: 1,
            CONFIGURABLE: 0,
            TABTYPE: null,
            cellWidth: '50%',
            bgColor: 'hsla(197, 69%, 50%, 0.86)',
            blurBackgroundImg: require('@/assets/Home/Sticker/news.jpg'),
            contentVisibleStu: false
          },
          {
            CARDCODE: 'Book',
            PARENTID: '2',
            MAXWIDTH: '99%',
            SEQUENCE: 5,
            CARDNAME: '图书',
            ISCOLLECT: 1,
            CARDPICTUREURL: 'service/servicePic/1585408775765_2f7505b4-1b67-4e4c-b698-f13fde95b8c0.png',
            MAXHEIGHT: 1,
            ID: '2004',
            DRAGGABLE: 1,
            CONFIGURABLE: 0,
            TABTYPE: null,
            cellWidth: '50%',
            bgColor: 'hsla(195, 100%, 36%, 0.86)',
            blurBackgroundImg: require('@/assets/Home/Sticker/news.jpg'),
            contentVisible: false
          },
          {
            CARDCODE: 'Schedule',
            PARENTID: '2',
            MAXWIDTH: '99%',
            SEQUENCE: 6,
            CARDNAME: '今日日程',
            ISCOLLECT: 1,
            CARDPICTUREURL: 'service/servicePic/1585408927628_72dfb215-7a52-4424-8c44-5c0a9544e42e.png',
            MAXHEIGHT: 1,
            ID: '2007',
            DRAGGABLE: 1,
            CONFIGURABLE: 1,
            TABTYPE: null,
            cellWidth: '50%',
            bgColor: 'hsla(30, 6%, 67%, 0.86)',
            blurBackgroundImg: require('@/assets/Home/Sticker/news.jpg'),
            contentVisibleStu: false
          },
          {
            CARDCODE: 'Mail',
            PARENTID: '2',
            MAXWIDTH: '99%',
            SEQUENCE: 7,
            CARDNAME: '邮箱',
            ISCOLLECT: 1,
            CARDPICTUREURL: 'service/servicePic/1585408835862_acd5021c-8793-4fc4-9fd3-53726d153ce7.png',
            MAXHEIGHT: 1,
            ID: '2002',
            DRAGGABLE: 1,
            CONFIGURABLE: 0,
            TABTYPE: null,
            cellWidth: '50%',
            bgColor: 'hsla(261, 11%, 58%, 0.86)',
            blurBackgroundImg: require('@/assets/Home/Sticker/news.jpg'),
            contentVisibleStu: false
          },
          {
            CARDCODE: 'Events',
            PARENTID: '2',
            MAXWIDTH: '198.8%',
            SEQUENCE: 8,
            CARDNAME: '事务中心',
            ISCOLLECT: 1,
            CARDPICTUREURL: 'service/servicePic/1585408816979_004ed450-62e6-40ad-9559-44e8a398eb83.png',
            MAXHEIGHT: 2,
            ID: '2006',
            DRAGGABLE: 1,
            CONFIGURABLE: 0,
            TABTYPE: null,
            cellWidth: '50%',
            bgColor: 'hsla(57, 78%, 39%, 0.86)',
            blurBackgroundImg: require('@/assets/Home/Sticker/news.jpg'),
            contentVisibleStu: false
          }
        ],
        componentListWithBg: [],
        // 校园旅程
        trip: [
          {
            label: '新生报到',
            img: require('@/assets/Home/Sticker/xinshengbaodao.png')
          },
          { label: '入学', img: require('@/assets/Home/Sticker/ruxue.png') },
          {
            label: '校园生活',
            img: require('@/assets/Home/Sticker/xiaoyuanshenghuo.png')
          },
          {
            label: '实习生活',
            img: require('@/assets/Home/Sticker/shixishenghuo.png')
          },
          {
            label: '就业招聘',
            img: require('@/assets/Home/Sticker/jiuyezhaopin.png')
          },
          {
            label: '毕业离校',
            img: require('@/assets/Home/Sticker/biyelixiao.png')
          },
          {
            label: '校友活动',
            img: require('@/assets/Home/Sticker/xiaoyouhuodong.png')
          }
        ],
        currentTrip: '新生报到',
        // 收藏 - 系统
        serviceList: [
          {
            id: 'app01',
            name: 'OA 系统',
            icon: require('@/assets/App/oa.png')
          },
          {
            id: 'app02',
            name: '打印系统',
            icon: require('@/assets/App/print.png')
          },
          {
            id: 'app03',
            name: '奖助金系统',
            icon: require('@/assets/App/grant.png')
          },
          {
            id: 'app04',
            name: '教务系统',
            icon: require('@/assets/App/ea.png')
          },
          {
            id: 'app05',
            name: '科研系统',
            icon: require('@/assets/App/research.png')
          },
          {
            id: 'app6',
            name: '离校系统',
            icon: require('@/assets/App/leaving_school.png')
          },
          {
            id: 'app7',
            name: '资产系统',
            icon: require('@/assets/App/assets.png')
          }
        ]
      };
    },
    created() {
      // this.handleGetComponents();
      this.getColors();
    },
    methods: {
      // 青海大学点击小机器人跳转
      handleLink() {
        window.open('https://qhu.campusphere.net/wec-amp-boya/login?appId=wx9e683eed64441028');
      },
      // 获取展示的卡片
      handleGetComponents() {
        getUserComponents('2').then(res => {
          if (res.data.data.code === 200) {
            this.componentList = res.data.data.items.filter(item => {
              return item.ISCOLLECT === 1;
            });
          } else {
            this.$message.error('获取组件失败，请尝试重新登录。');
          }
        });
      },
      updateContentVisible(obj) {
        this.componentListWithBg.forEach(item => {
          item.contentVisibleStu = false;
        });
        const { sequence, contentVisibleStu } = obj;
        let newObj = this.componentListWithBg[sequence];
        newObj.contentVisibleStu = contentVisibleStu;
        this.componentListWithBg.splice(sequence, 1, newObj);
      },
      getColors() {
        const colorThief = new ColorThief();
        const originImg = document.createElement('img');
        originImg.addEventListener('load', () => {
          let originImgWidth = originImg.width;
          let originImgHeight = originImgWidth * 0.618;
          let halfWidth = originImgWidth * 0.5;
          let halfHeight = originImgWidth * 0.5 * 0.618;
          let quarterWidth = originImgWidth * 0.5 * 0.5;
          let quarterHeight = originImgWidth * 0.5 * 0.5 * 0.618;
          let posInfos = [
            {
              left: 0,
              top: 0,
              width: halfWidth,
              height: halfHeight
            },
            {
              left: 0,
              top: halfHeight,
              width: quarterWidth,
              height: quarterHeight
            },
            {
              left: quarterWidth,
              top: halfHeight,
              width: quarterWidth,
              height: quarterHeight
            },
            {
              left: halfWidth,
              top: 0,
              width: quarterWidth,
              height: quarterHeight
            },
            {
              left: halfWidth + quarterWidth,
              top: 0,
              width: quarterWidth,
              height: quarterHeight
            },
            {
              left: halfWidth,
              top: quarterHeight,
              width: quarterWidth,
              height: quarterHeight
            },
            {
              left: halfWidth + quarterWidth,
              top: quarterHeight,
              width: quarterWidth,
              height: quarterHeight
            },
            {
              left: halfWidth,
              top: halfHeight,
              width: quarterWidth,
              height: quarterHeight
            },
            {
              left: halfWidth + quarterWidth,
              top: halfHeight,
              width: quarterWidth,
              height: quarterHeight
            }
          ];

          // 把图片内容使用canvas画到画板上；
          const originCanvas = document.createElement('canvas');
          const originCanvasTx = originCanvas.getContext('2d');
          originCanvas.width = originImgWidth;
          originCanvas.height = originImgHeight;
          originCanvasTx.drawImage(originImg, 0, 0, originImgWidth, originImgHeight);
          this.componentListWithBg = [];
          let mediaArr = [];
          posInfos.forEach((item, index) => {
            let sliceCanvas = document.createElement('canvas');
            let sliceCanvasTx = sliceCanvas.getContext('2d');
            let sliceCanvasImageData = originCanvasTx.getImageData(item.left, item.top, item.width, item.height);
            sliceCanvas.width = item.width;
            sliceCanvas.height = item.height;
            sliceCanvasTx.rect(0, 0, item.width, item.height);
            sliceCanvasTx.fillStyle = 'white';
            sliceCanvasTx.fill();
            sliceCanvasTx.putImageData(sliceCanvasImageData, 0, 0);

            // imageData, dx, dy
            // 创建img 块
            let img = document.createElement('img');
            img.addEventListener('load', () => {
              const bgColorArr = colorThief.getColor(img) || [];
              let hslColor = rgbToHsl(bgColorArr);
              this.componentList[index].bgColor = `hsla(${hslColor[0]},${hslColor[1] + 50}%,${hslColor[2] > 70 ? 70 : hslColor[2]}%, 0.86)`;
              mediaArr[index] = this.componentList[index];
              // 处理因为图像请求速度不一样，而导致的返回数据顺序不一样的问题
              this.componentListWithBg = [];
              if (mediaArr.length === 9) {
                mediaArr.forEach((item1, index1) => {
                  this.componentListWithBg.push(mediaArr[index1]);
                });
              }
            });
            img.crossOrigin = 'Anonymous';
            img.src = sliceCanvas.toDataURL('image/jpeg');
            this.componentList[index].blurBackgroundImg = img.src;
          });
        });
        originImg.crossOrigin = 'Anonymous';
        originImg.src = this.backgroundImg;
      }
    }
  };
</script>
<style lang="scss">
  @import '@/styles/variables.scss';
  .icon-robot{
    position: fixed;
    bottom: 80px;
    right: 30px;
  }
  .section-content {
    max-width: 1920px;
    margin: 0 auto;
    &.chongyiStudent{
      padding: 0;

    }
  }
  .sticker {
    flex: 1;
    &-modules-container {
      background-size: 100% auto;
      filter: var(--color-filter, hue-rotate(0deg));
      position: relative;
    }

    &-content {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      width: 100%;
      box-sizing: border-box;

      &-left,
      &-right {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-content: flex-start;
        width: 50%;
        box-sizing: border-box;
      }

      &-left {
        .sticker-card {
          &:nth-child(1) {
            box-sizing: border-box;
          }
          &:nth-last-child(1) {
            box-sizing: border-box;
          }

          &:nth-last-child(2) {
            box-sizing: border-box;
          }
        }
      }

      &-right {
        .sticker-card {
          box-sizing: border-box;
          &:nth-child(2n-1) {
          }

          &:nth-child(2n) {
          }

          &:nth-child(5),
          &:nth-child(6) {
          }
          &:nth-child(1) {
          }
          &:nth-child(2) {
          }
        }
      }
    }

    &-content + &-content {
      margin-top: 30px;
    }

    .components-title {
      padding-top: 50px;
      padding-bottom: 40px;
    }

    .SortServe {
      width: 100%;
      margin: 50px auto;

      .SortServe-trip-item {
        width: 130px;
        height: auto;

        > img {
          width: 130px;
          height: 130px;
        }

        .SortServe-trip-line {
          left: 0;
          right: 0;
        }
      }

      .SortServe-app {
        width: 100%;
      }
    }

    &-card {
      &:not(.sticker-news) {
        &:hover {
          z-index: 1;
        }
      }

      .sticker-news {
        &-name {
          width: 188px;
          height: 188px;

          > svg {
            width: 52px;
            height: 52px;
            margin-top: 37px;
          }

          i {
            display: block;
            width: 138px;
            height: 1px;
            margin: 14px 25px 0;
            background-color: rgba(255, 255, 255, 0.29);
          }

          > span {
            margin-top: 16px;
            font-size: 26px;
            line-height: 26px;
          }
          > span.number {
            margin-top: 10px;
            font-size: 22px;
          }
        }
      }

      position: relative;
      background-position: center;
      background-size: cover;
      transition: $transition-primary;

      &-name {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        margin: auto;
        width: 116px;
        height: 116px;
        border-radius: 50%;
        transition: $transition-primary;
        display: flex;
        flex-direction: column;
        align-items: center;
        color: #fff;

        > svg {
          margin-top: 12px;
          width: 34px;
          height: 34px;
        }

        > i {
          display: block;
          width: 80px;
          height: 1px;
          margin: 10px 18px 0;
          background-color: rgba(255, 255, 255, 0.29);
        }

        > span {
          margin-top: 12px;
          font-size: 18px;
          line-height: 18px;
        }
        > span.number {
          margin-top: 6px;
          font-size: 16px;
        }
        &:hover {
          cursor: pointer;
        }
      }

      &-content {
        color: #fff;
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        padding: 20px;
        position: absolute;
        left: 0;
        bottom: 0;
        z-index: 3;
        overflow: scroll;
        background-color: rgba($color: #000, $alpha: 0.7);
        .closeModule {
          position: absolute;
          width: 0;
          height: 0;
          right: 0;
          top: 0;
          border: 20px solid transparent;
          border-right-color: rgba(0, 0, 0, 0.6);
          border-top-color: rgba(0, 0, 0, 0.6);
          &:after {
            content: '';
            position: absolute;
            top: -15px;
            right: auto;
            width: 15px;
            height: 15px;
            background: url('../../assets/Home/Sticker/changeStatus.png') no-repeat 0 100%;
            background-size: 15px;
          }
          &:hover {
            cursor: pointer;
          }
        }

        &-container {
          position: relative;
          z-index: 1;
          width: 100%;
          height: 100%;
          overflow: hidden;
          background-repeat: no-repeat;
          background-size: 100% 100%;
          &:after {
            content: '';
            width: 110%;
            height: 120%;
            position: absolute;
            left: 0;
            top: -10%;
            z-index: 2;
            background: inherit;
            filter: blur(20px);
          }
        }
      }
    }
  }
</style>
